import { $api } from "../generated/client";

type SizingDailyRecommendationsParams = {
	shopId: string;
	fromTimestamp?: number;
	toTimestamp?: number;
};

export default function useSizingDailyRecommendations({
	shopId,
	...params
}: SizingDailyRecommendationsParams) {
	return $api.useQuery("get", "/shops/{shopId}/sizing/recommendations/daily", {
		params: { path: { shopId }, query: params },
		enabled: !!shopId,
	});
}
